import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { stampWriteOffReasons } from '../../../../../../constants/entity-enums/stamp-write-off-reasons'
import { requiredRules } from '../../../../../../constants/forms/validation/rules'
import { NamePath } from 'antd/es/form/interface'

interface ReasonProps {
    name?: NamePath
}

const Reason: FC<ReasonProps> = ({ name = 'reason' }) => {
    return (
        <Form.Item name={name} label={'Причина'} rules={requiredRules}>
            <Select options={stampWriteOffReasons.map(item => ({ value: item }))} />
        </Form.Item>
    )
}

export default Reason
